import { useQuery } from '@tanstack/react-query';
import { usePrivyAccount } from './use-privy-account';
import { getAccount, getAssociatedTokenAddress } from '@solana/spl-token';
import { USDC_MINT_ADDRESS } from '@/lib/wagmi/config';
import { PublicKey } from '@solana/web3.js';
import { useConnection } from '@solana/wallet-adapter-react';
import { NetworkType } from '@/types';
import { useAccountStore } from '@/store/use-account-store';

const getSolanaBalanceQueryKey = (address?: string) => [
  'solana/balance',
  address,
];

export default function useSolanaBalance(options?: { disabled?: boolean }) {
  const address = useAccountStore((state) => state.address);
  const { networkType } = usePrivyAccount();
  const { connection } = useConnection();

  const enabled =
    !options?.disabled && !!address && networkType === NetworkType.SOLANA;

  const { data, ...query } = useQuery({
    queryKey: getSolanaBalanceQueryKey(address),
    queryFn: async () => {
      if (!address) return 0n;
      const publicKey = new PublicKey(address);

      try {
        // Get the associated token address for USDC
        const usdcTokenAccount = await getAssociatedTokenAddress(
          new PublicKey(USDC_MINT_ADDRESS),
          publicKey,
        );

        // Get the account info for the token address
        const accountInfo = await getAccount(connection, usdcTokenAccount);

        // Convert balance from raw lamports to tokens (USDC has 6 decimal places)
        return accountInfo.amount;
        // setIsBalanceLoading(false);
      } catch (error) {
        console.error('Error fetching USDC balance:', error);
        return 0n;
      }
    },
    enabled,
  });

  return { ...query, value: data ?? 0n };
}
